import { render, staticRenderFns } from "./EditEtapa.vue?vue&type=template&id=2817298a"
import script from "./EditEtapa.vue?vue&type=script&lang=js"
export * from "./EditEtapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports